// extracted by mini-css-extract-plugin
export default {"productGallery":"wM-z","inQuickShop":"xM-z"};